import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface IssueCategory {
  zIssueCategoryId: number;
  nameEn: string;
  nameAr: string;
}

export interface CreateSupportTicket {
  fullName: string;
  mobile: string;
  email: string;
  branchName: string;
  zIssueCategoryId: number;
  subject: string;
  issueDesc: string;
}

export interface SupportTicketResponse {
  supportId: string;
}

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  private apiBase = 'https://pos.qootk.com/api/ZOut';
  //private apiBase = 'http://localhost:5083/api/ZOut';

  constructor(private http: HttpClient) {}

  getIssueCategories(): Observable<IssueCategory[]> {
    return this.http.get<IssueCategory[]>(`${this.apiBase}/issueCategories`);
  }

  submitSupportTicket(ticket: CreateSupportTicket): Observable<SupportTicketResponse> {
    return this.http.post<SupportTicketResponse>(`${this.apiBase}/supportTicket`, ticket);
  }
}
